import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/list', qs.stringify(params))
}

export const getListfixcilumn = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/listfixcolumn', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/edit', qs.stringify(params))
}

export const querygoodsv2 = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/querygoodsv2', qs.stringify(params))
}

export const changelensrule = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/changelensrule', qs.stringify(params))
}

export const getbatchdetail = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getbatchdetail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/set/jxcgoodsdetail/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/set/jxcgoodsdetail/save', qs.stringify(params))
  }
}

//镜架导入
export const jingjiaupload = (params) => {
  let config = {
    timeout: 1000 * 60 * 2
  };   //添加请求
  return axios.post(root + '/set/jxcgoodsdetail/jingjiaupload', qs.stringify(params), config)
}
export const jingjiaParamupload= (params) => {
  let config = {
    timeout: 1000 * 60 * 2
  };   //添加请求
  return axios.post(root + '/set/jxcgoodsdetail/jingjiaParamupload', qs.stringify(params), config)
}

export const pandianInit = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/pandianInit', qs.stringify(params))
}
export const pandianLensInit = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/pandianLensInit', qs.stringify(params))
}
export const pandian40Init = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/pandian40Init', qs.stringify(params))
}

export const buyorderInit = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/buyorderInit', qs.stringify(params))
}

//获取产品类型树
export const getGoodsTree = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/tree', qs.stringify(params))
}

export const listgoodsframe= (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/goodsframe', qs.stringify(params))
}

export const updateupandlow = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/updateupandlow', qs.stringify(params))
}

export const getSimpleDetail = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getsimpledetail', qs.stringify(params))
}

export const updateadvertisement = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/updateadvertisement', qs.stringify(params))
}

//查询当前货品的数量
export const count = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/count', qs.stringify(params))
}

export const list4PriceSet = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/list4PriceSet', qs.stringify(params))
}

export const initBarCode = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/initBarCode', qs.stringify(params))
}

export const getBarCode = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getBarCode', qs.stringify(params))
}

export const getscreen = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/screen', qs.stringify(params), {headers: {"tenantid": params.tenantid}})
}
export const getquerygoodsv2 = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/querygoodsv2', qs.stringify(params), {headers: {"tenantid": params.tenantid}})
}

export const hsave = (params) => {
  return axios.post(root + '/order/jxcglassessell/checkXY', qs.stringify(params))
}

//修改图片随机码
export const updateImg = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/updateImg', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jxcgooddetail.js